
import { supabase } from '../../../integrations/supabase/client';

// Update user profile with teacher_id if not already set
export const updateUserProfile = async (
  userEmail: string, 
  teacherId: string, 
  teacherDisplay: string | null,
  toast: any
) => {
  try {
    // Check if profile exists and if teacher_id is already set
    const { data: existingProfile, error: fetchError } = await supabase
      .from('profiles')
      .select('teacher_id, teacher_display, id')
      .eq('email', userEmail)
      .single();
    
    if (fetchError && fetchError.code !== 'PGRST116') { // PGRST116 is "no rows returned"
      console.error('Error fetching user profile:', fetchError);
      return;
    }

    // If no profile exists, or teacher_id is not set, update it
    if (!existingProfile || !existingProfile.teacher_id) {
      const updateData = {
        id: existingProfile.id,
        email: userEmail,
        teacher_id: teacherId,
        teacher_display: teacherDisplay || teacherId,
        updated_at: new Date().toISOString(),
      };
      
      const { error: updateError } = await supabase
        .from('profiles')
        .upsert(updateData);
      
      if (updateError) {
        console.error('Error updating user profile:', updateError);
        toast({
          title: 'ข้อผิดพลาด',
          description: 'ไม่สามารถอัปเดตข้อมูลโปรไฟล์ได้',
          variant: 'destructive',
        });
      } else {
        console.log('User profile updated with teacher ID');
      }
    }
  } catch (error) {
    console.error('Unexpected error in updateUserProfile:', error);
  }
};
